import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { formatPrice } from "../lib/api";
import { Trash2, Minus, Plus, ShoppingBag } from "lucide-react";

export default function Cart() {
  const { cart, updateQty, removeFromCart, cartTotal } = useStore();

  if (cart.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="cart-empty">
        <ShoppingBag size={48} className="text-gold mx-auto mb-6" strokeWidth={1} />
        <h1 className="font-serif text-3xl text-navy">Количката е празна</h1>
        <p className="text-charcoal/60 mt-3">Открийте картина, която ще промени дома ви.</p>
        <Link to="/kartini" className="btn-gold inline-block px-8 py-3 rounded-sm mt-8">Разгледай картините</Link>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12" data-testid="cart-page">
      <h1 className="font-serif text-3xl md:text-4xl text-navy mb-8">Вашата количка</h1>
      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          {cart.map((i) => (
            <div key={i.id} className="flex gap-4 bg-white border border-stone p-4" data-testid={`cart-item-${i.id}`}>
              <img src={i.image} alt={i.title} className="w-24 h-28 object-cover bg-stone" />
              <div className="flex-1">
                <h3 className="font-serif text-lg text-navy">{i.title}</h3>
                <p className="text-xs text-charcoal/50">{i.size}</p>
                <p className="text-gold font-serif text-lg mt-1">{formatPrice(i.price)}</p>
                <div className="flex items-center gap-4 mt-2">
                  <div className="flex items-center border border-stone">
                    <button onClick={() => updateQty(i.id, i.qty - 1)} className="px-2 py-1.5 text-navy" data-testid={`qty-minus-${i.id}`}><Minus size={14} /></button>
                    <span className="px-3 text-sm" data-testid={`qty-${i.id}`}>{i.qty}</span>
                    <button onClick={() => updateQty(i.id, i.qty + 1)} className="px-2 py-1.5 text-navy" data-testid={`qty-plus-${i.id}`}><Plus size={14} /></button>
                  </div>
                  <button onClick={() => removeFromCart(i.id)} className="text-charcoal/40 hover:text-red-500" data-testid={`remove-${i.id}`}><Trash2 size={16} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white border border-stone p-6 h-fit">
          <h2 className="font-serif text-xl text-navy mb-4">Обобщение</h2>
          <div className="flex justify-between text-sm py-2 border-b border-stone"><span className="text-charcoal/60">Междинна сума</span><span className="text-navy">{formatPrice(cartTotal)}</span></div>
          <div className="flex justify-between text-sm py-2 border-b border-stone"><span className="text-charcoal/60">Доставка</span><span className="text-gold">Безплатна</span></div>
          <div className="flex justify-between font-serif text-lg py-3"><span className="text-navy">Общо</span><span className="text-navy" data-testid="cart-total">{formatPrice(cartTotal)}</span></div>
          <Link to="/checkout" className="btn-gold block text-center py-3.5 rounded-sm mt-4" data-testid="checkout-btn">Към поръчка</Link>
          <Link to="/kartini" className="block text-center text-sm text-navy mt-4 hover:text-gold">Продължи пазаруването</Link>
        </div>
      </div>
    </div>
  );
}
